var map = {
	"./AIOconfig.svg": "402b",
	"./activity.svg": "6736",
	"./batch.svg": "d4b9",
	"./carbon_close.svg": "0328",
	"./class.svg": "08f6",
	"./close.svg": "7710",
	"./coach.svg": "b83c",
	"./content.svg": "33c4",
	"./content1.svg": "e428",
	"./curriculumCollectionManagement.svg": "401d",
	"./down.svg": "d681",
	"./downLoad.svg": "0477",
	"./ec.svg": "e16b",
	"./error.svg": "b1b9",
	"./file.svg": "b8b2",
	"./file1.svg": "6006",
	"./goods.svg": "7421",
	"./import.svg": "264a",
	"./log.svg": "fea0",
	"./lottery.svg": "558d",
	"./member.svg": "daf4",
	"./online_activity.svg": "30ec",
	"./photo.svg": "6532",
	"./public.svg": "d83f",
	"./question.svg": "ae00",
	"./register.svg": "7461",
	"./store.svg": "443b",
	"./success.svg": "a8cf",
	"./template.svg": "dcbb",
	"./today.svg": "cd09",
	"./toolbox.svg": "0555",
	"./up.svg": "1380",
	"./vote.svg": "570d",
	"./warn.svg": "f809",
	"./xls.svg": "58bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";